<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.customerGroupId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
            <FilterGroup :title="$t('servicesystem.common_objects.commonterms.data_quality')"
              :applied-filters="[imageFilter]">
              <v-row no-gutters justify="start" align="center" class="pb-3">
                <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.commonterms.image") }}:</p>
                <QButtonGroup v-model="imageFilter" :list="imageFilterOptions" :edit="true" dense noempty>
                </QButtonGroup>
              </v-row>
            </FilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list>
        <ListPane :getListMethod="getCustomerGroupListFromFilter" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="75" :open-function="openItem"
          :dialogItem="editItem" :dialog-trigger="dialogtrigger" :dialog-method-config="dialogMethodConfig"
          ref="ListPane" :pk="pk" @Added="item => openItem(item)">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="openItem(item)">
            </ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <CustomerGroupEditContent :key="trigger" :editItem="item" :originalItem="editItem" :editMode="true"
              :handleFocus="() => { }">
            </CustomerGroupEditContent>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import FilterGroup from "@/components/FilterGroup.vue";
import ListItem from "@/components/ListItems/CustomerGroupListItem.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import Layout from "@/views/layouts/PreviewableList.vue";
import CustomerGroupEditContent from "./CustomerGroupEditContent.vue";

export default {
  name: "AdminCustomerGroups",
  props: {},
  components: {
    ListPane,
    FilterPane,
    Layout,
    ListItem,
    FilterGroup,
    DefaultLifeCycleFilterGroup,
    CustomerGroupEditContent,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "ACG-",
      imageFilterOptions: [
        { value: 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: 1, text: this.$t("servicesystem.common_objects.commonterms.with") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.without") },
      ],
      dialogtrigger: 1,
      editItem: {},
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createCustomerGroup',
        },
      }
    };
  },

  mounted() { },

  methods: {
    openItem(item) {
      var query = (this.$route.name == "CustomerGroupList") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewCustomerGroup', params: { customerGroupId: item.Id }, query })
    },

    setEditItem(item) {
      if (item) {
        this.editItem = Object.assign({}, item);
      }
      else {
        var defaultItem = {
          IsActive: true,
        };
        this.editItem = defaultItem;
      }
      this.dialogtrigger++;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          ImageState: this.imageFilter,
        };
        return filters;
      }
      else {
        return null;
      }
    },

    imageFilter: {
      get() { return this.getQueryParam("filter-image", 0); },
      set(update) { this.setQueryParam("filter-image", update); },
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>